import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { NavLink } from 'react-router-dom';
import SignOut from './SignOut';
import '../style/navbar.css';

class Header extends React.Component {
	render() {
		return (
			<Navbar collapseOnSelect expand="lg" variant="dark">
				<Navbar.Brand id="logo" href="/community">
				<img
					className="rotate"
					alt="logo"
					src="/doge.svg"
					// className="d-inline-block align-center"
				/>PSSSSD MEMES
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="responsive-navbar-nav" />
				<Navbar.Collapse id="responsive-navbar-nav">
					<Nav className="ms-auto">
						{/* <Nav.Link> */}

						<NavLink
							className="navlink"
							to="/creativity"
							style={({ isActive }) => ({ width: "100px", color: "#FF6700", "font-weight": isActive ? 700 : 400 })}
						>Creativity
						</NavLink>
						{/* </Nav.Link>
						<Nav.Link> */}
						<NavLink
							className="navlink"
							to="/community"
							style={({ isActive }) => ({ width: "100px", color: "#C4ED74", "font-weight": isActive ? 700 : 400 })}
							>Community
							</NavLink>
						{/* </Nav.Link>
						<Nav.Link> */}
						<NavLink
							className="navlink"
							to="/collaboration"
							style={({ isActive }) => ({ width: "100px", color: "#F2B5F7", "font-weight": isActive ? 700 : 400 })}
							>Collaboration
							</NavLink>
						{/* </Nav.Link> */}
						<Nav.Link id="right-nav-item">
							{	this.props.isAuthenticated &&
								<SignOut signOut={this.props.signOut} className="navItem align-center"></SignOut>
							}
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		);
	}
}

export default Header;
